export default __webpack_public_path__ + "static/media/itempage-image-1.7f798a7c.jpg";